module.exports = __webpack_public_path__ + "media/images/pic/hero/mobile-a64bf7c5199d1c74c18c8387d00dc397.webp";